import React from "react";
import styled from "@emotion/styled";
import { CardForm, Box, Image, Text, Link } from "@atoms";

// == Types ================================================================

interface IProps {}

// == Constants ============================================================

CheckoutHelp.defaultProps = {};

// == Component ============================================================

export default function CheckoutHelp(props: IProps) {
  return (
    <Box mt={3} px={["24px", 0]} pb={5}>
      <ELink target="_blank" href="mailto:support@flipgive.com">
        support@flipgive.com
      </ELink>
      <Text color="primary">1-844-438-3547</Text>
    </Box>
  );
}

// == Styles ===============================================================

const ELink = styled(Link)`
  display: block;
`;
